<template>
  <div class="col-lg-6 col-12" style="height:100%; margin: auto;" v-loading="LOADING">
    <el-timeline v-show="!LOADING">
      <el-timeline-item :timestamp="exercise.exercise.name" placement="top" v-for="(exercise, index) in exercisesForCurrentDay" :key="index">
        <el-card>
          <dynamic-video video-style="width: 100%;" v-if="exercise.exercise.illustration && exercise.exercise.illustration.animation && exercise.exercise.illustration.animation.hostingProvider == 'LOCAL'" :file-id="exercise.exercise.illustration.animation.id" :options="{ autoplay: true,controls:false}" loop>
          </dynamic-video>
          <!-- <video v-else :src="exercise.exercise.illustration.animation" style="width: 100%;margin: auto" autoplay loop></video> -->
          <div v-else> video not configured</div>
          <div style="position: absolute;top: 0px;right: 0px;padding: 0.7rem;background-color: grey; border-bottom-left-radius: 4px;color: #fff;font-weight: 900">
            <span v-if="exercise.exercise.durationType == 'reps'">x</span>
            <span>{{exercise.duration}}</span>
            <span v-if="exercise.exercise.durationType == 'time'" class="pl-1">s</span>
          </div>
        </el-card>
      </el-timeline-item>
    </el-timeline>

    <n-button type="primary" round size="lg" @click.native="
                  startToTrain()
                " style="
                  top: auto;
                  bottom: 0px;
                  left: 50%;
                  transform: translateX(-50%);
                  position: fixed;
                  font-weight: 600
                ">
      {{$t('message.START')}}
    </n-button>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "videos",

  created() {},

  data() {
    return {
      LOADING: true,
    };
  },

  async mounted() {
    this.$root.onBackButton = () => {
      if (this.$store.state.trainingType == "yoga") {
        this.$router.push("/yogaschedule");
      } else {
        this.$router.push("/fitnessschedule");
      }
    };
    let that = this;
    try {
      this.setAppHeaderText(this.training.title);

      let exerciseFunction = "getExercisesForTheDay";
      if (this.$store.state.trainingType == "yoga") {
        exerciseFunction = "getYogaExercisesForTheDay";
      }

      let exercisesForCurrentDay = (
        await this.$store.dispatch(exerciseFunction, {
          trainingId: this.$store.state.training._id,
          dayIndex: this.$store.state.currentTrainingDayIndex,
        })
      ).data;

      await this.$store.commit("setState", {
        stateName: "exercisesForCurrentDay",
        stateValue: exercisesForCurrentDay,
      });
      that.LOADING = false;
    } catch (error) {
      that.LOADING = false;
      console.log(error);
    }
  },

  beforeDestroy() {
    this.$root.onBackButton = null;
  },

  computed: {
    ...mapState({
      training: (state) => state.training,
    }),
    exercisesForCurrentDay() {
      return this.$store.state.exercisesForCurrentDay;
    },
  },

  methods: {
    startToTrain() {
      this.$router.push("/exercise");
    },
  },
};
</script>

<style scoped>
/deep/ .el-loading-mask {
  background: #fff !important;
}
/deep/ .el-card__body {
  text-align: center;
  position: relative;
}
/deep/ .el-timeline-item__timestamp {
  font-size: 1.1rem;
  text-transform: uppercase;
}
</style>
